export default __webpack_public_path__ + "static/media/rebar_amount.edb7b742.svg";